import { DELI_ENV_BASE_URL, http_v3 } from '@api/client';
import * as companyService from '@api/company';
import { companyRequestApi as companyRequestService } from '@api/company-request';
import * as contentService from '@api/content';
import * as personService from '@api/person';
import * as pintService from '@api/pint';
import { ColoredChip } from '@components/colored-elements';
import { EntityIcon } from '@components/entity-type-icon';
import SearchBox from '@components/search-box';
import { AiOutlineInfoCircle, BsPencilSquare } from '@icon/react-icons';
import * as roleApi from '@api/role';
import { usePintMaster, useSnackbarInstance } from '@lib/common';
import CircularProgress from '@material-ui/core/CircularProgress';
import { blue } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import {
  capitalCase,
  useRecentInjector,
  useServerPagination,
  useToggle,
  vtrUrl
} from '@lib/common';
import { thumbStack } from '@lib/common/css';
import { EntityType } from '@lib/deals';
import {
  Avatar, Button, Card,
  CardContent,
  CardHeader,
  Chip, Collapse, createStyles, FormControl,
  Grid,
  IconButton,
  InputLabel, Link, makeStyles, MenuItem,
  Select, TextField, Tooltip, Typography
} from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import { grey, red } from '@material-ui/core/colors';
import InputBase from '@material-ui/core/InputBase';
import { withStyles } from '@material-ui/core/styles';
import { DataGrid, DataGridProps } from '@material-ui/data-grid';
import AddToQueueIcon from '@material-ui/icons/AddToQueue';
import BackspaceIcon from '@material-ui/icons/Backspace';
import CancelIcon from '@material-ui/icons/Cancel';
import CategoryIcon from '@material-ui/icons/Category';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import EventIcon from '@material-ui/icons/Event';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LanguageIcon from '@material-ui/icons/Language';
import LaunchIcon from '@material-ui/icons/Launch';
import NotInterestedRoundedIcon from '@material-ui/icons/NotInterestedRounded';
import SubtitlesIcon from '@material-ui/icons/Subtitles';
import { Skeleton } from '@material-ui/lab';
import clsx from 'clsx';
import { isValid } from 'date-fns';
import { useSnackbar } from 'notistack';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { Link as Link1 } from 'react-router-dom';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { useCompanyLoader } from 'services/company-dataloader.service';
import { contentDataLoader, useContentLoader } from 'services/content-dataloader.service';
import { usePersonLoader } from 'services/person-dataloader.service';
import styled from 'styled-components';
import { contentToColumns, getBadgeColor } from './columns';
import { CreateEntityRequest } from './entity-request';
import { COMPANY_TO_CONTENT } from 'pages/company-content/company-content-form/company-content-relation-form';
import { CONTENT_PAGE } from 'pages/common/person-dropdown-list';
import { ControlledTextField } from 'pages/person-management/person-management-form/person-master-relation-form';
import { ControlledTextFieldforCharacter } from 'pages/content/form/cast-crew-associated/CastandCrewDialogContent_v2';
import { CONTENT_TO_PERSON } from '@pages/c3-page/add/content-person-relation';
import { QUOTES_POLICIES } from '@pages/quotes-policies/qp-features/qp-add-entities';
import { debounce } from 'lodash';
import { computeReputationBadge} from '@pages/company-reputation-score/Tabs/CompanyReputationTab/BadgeConfig';
import ClipBoard from '@pages/company/search/columns/utils';
import CopyClipboard from '@material-ui/icons/AttachFile';

interface EntitySearchModel {
  vtr_id: string;
  type: string;
  name: string;
  relation_type: string;
  meta?: any;
  //Below are for clearing already existing data in partial entity
  imdb_id?: string;
  deal_id?: number | string;
  confidence?: number;
  deal_content_genre?: string;
  language?: string;
  country_of_origin?: string;
  deal_content_type?: string;
  book_name?: string;
  working_title?: string;
  deal_season?: string;
  original_title?: string;
  publish?: number;
  hqcountry?: string;
  person_vtr_id?: boolean;
  company_vtr_id?:string;
  _autoSelect?: boolean;
}

interface EntitySearchProps {
  label: string;
  hideTypeSelect?: boolean;
  clearable?: boolean;
  defaultValue?: EntitySearchModel;
  onChange?: (value: EntitySearchModel) => any;
  changeBuyer?: (value: EntitySearchModel) => any;
  changeSeller?: (value: EntitySearchModel) => any;
  titleEditable?: boolean;
  fixedType?: string;
  tryDefaultMetaPopulate?: boolean;
  indexOfEntities: number;
  removeDealEntities?: (index: number) => void;
  isDealEntityRemovable?: boolean;
  isDealEntityRequestCreatable?: boolean;
  dealData?: any;
  disabled?: boolean;
  defaultSearchIn?: string;
  stopInitialCall?: boolean;
  companyPublish?: number;
  companyPublishable?: boolean;
  contentPublish?: number;
  contentPublishable?: boolean;
  txtMessage?: string;
  addNonIdContentForm?: (contentTitle:String)=>void;
  switchBackToContentForm?: ()=>void;
  buyerValue?:[];
  isDealForm?: boolean;
  SeasonField?: any;
  addedFilters?: Filters[];
  page?: String;
  setUserSelected?: (value: any) => void;
  openByDefault?: boolean;
}

type Filters = {
  id: string;
  value: { 
    $in ?: string;
    $contains ?: string;
  }
}

const useEntityStyle = makeStyles(theme =>
  createStyles({
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    disabledCard: {
      background: grey[100],
    },
    hoverEditEntity: {
      '&:hover $editEntity': {
        opacity: 1,
      },
    },
    editEntity: {
      opacity: 0,
    },
    inputBaseStyle: {
      fontSize: '1.5rem',
    },
  })
);

export const EntitySearchMultiParty = forwardRef(({
  label,
  hideTypeSelect = false,
  clearable = false,
  defaultValue = { name: '', type: EntityType.company, vtr_id: '', relation_type: 'buyer' },
  onChange = null,
  changeBuyer = null,
  titleEditable = false,
  fixedType = '',
  tryDefaultMetaPopulate = true,
  indexOfEntities,
  removeDealEntities,
  isDealEntityRemovable = false,
  isDealEntityRequestCreatable = true,
  dealData = null,
  disabled = false,
  defaultSearchIn = 'name',
  stopInitialCall = false,
  companyPublish = 1,
  companyPublishable = false,
   contentPublish = 1,
  contentPublishable = false,
  txtMessage = 'No row',
  buyerValue = null,
  addNonIdContentForm = null,
  switchBackToContentForm = null,
  isDealForm = false,
  SeasonField = null,
  addedFilters = [],
  page="",
  setUserSelected = null,
  openByDefault = false,
}: EntitySearchProps, ref) => {
  const didMount = useRef(false);
  const [stopInitialCallRef, setStopInitialCallRef] = useState(stopInitialCall);
  const [expand, toggleExpanded] = useToggle(openByDefault || false);
  const [searchText, setSearchText] = useState(
    defaultSearchIn == 'vtr_id' ? defaultValue.vtr_id : defaultValue.name
  );
  const isSeller = label === 'Seller';
  const [type, setType] = useState(defaultValue.type);
  const [entityNameEditable, toggleEntityNameEditable] = useToggle(false);
  const classes = useEntityStyle();
  const resolvedType = fixedType || type || (EntityType.company as string);

  const [searchIn, setSearchIn] = useState(defaultSearchIn);
  const [searchInContent, setSearchInContent] = useState('title');

  const showSearchIn = resolvedType === EntityType.company || resolvedType === EntityType.person;
  const showSearchContentIdVtrId = resolvedType === EntityType.content;

  const [searchTrigger, setSearchTrigger] = useState(0);
  const [tableReload, setTableReload] = useState(false);
  // Entity Values
  const [entity, setEntityValue] = useState<EntitySearchModel>(defaultValue);
  const resolvedTypeValue = fixedType || entity.type || EntityType.company;
  // Form Change.
  const setPartialEntity = useRecentInjector(
    [onChange, setEntityValue, entity] as const,
    ([onChange, setEntityValue, entity], value: Partial<EntitySearchModel>) => {
      const newValue = { ...entity, ...value };
      setEntityValue(newValue);
      setUserSelected && setUserSelected(newValue);
      onChange && onChange(newValue);
      changeBuyer && changeBuyer(newValue);
    }
    
  );

  useImperativeHandle(ref, ()=>{
    return {
      setPartialEntity
    }
  })

  const entityNameEl = useRef(null);

  const isContentPage = page === CONTENT_PAGE;
  const isC3 = page === CONTENT_TO_PERSON
  const isQP = page === QUOTES_POLICIES
  const isC2C = page === 'COMPANY_TO_COMPANY';
  const typeContentPouplate =
    tryDefaultMetaPopulate && defaultValue.type === EntityType.content && defaultValue.vtr_id;

  const refreshTable = ()=>{
    setSearchText(searchText);
    setSearchTrigger(t => t + 1);
    resetPagination();
    setTableReload(true)
    toggleExpanded();
  }
  // State for auto-selection
  const [pendingAutoSelect, setPendingAutoSelect] = useState(false);
  const [autoSelectSearchText, setAutoSelectSearchText] = useState('');
  // Update searchText and entity when defaultValue changes (for pre-filling)
  useEffect(() => {
    if (defaultValue && defaultValue.name && defaultValue.name !== entity.name) {
      const newSearchText = defaultSearchIn === 'vtr_id' ? defaultValue.vtr_id : defaultValue.name;
      setSearchText(newSearchText || '');
      setEntityValue(defaultValue);
      setType(defaultValue.type);
      
      // Auto-select first matching entity if _autoSelect flag is set
      if (defaultValue._autoSelect && newSearchText) {
        setPendingAutoSelect(true);
        setAutoSelectSearchText(newSearchText);
        // Expand the search panel to show results
        if (!expand) {
          toggleExpanded();
        }
        // Trigger search to populate results
        setSearchTrigger(t => t + 1);
        resetPagination();
      }
    }
  }, [defaultValue?.name, defaultValue?.vtr_id, defaultValue?.type, defaultValue?._autoSelect]);

  // Try to populate content if required.
  useEffect(() => {
    if (typeContentPouplate) {
      contentDataLoader
        .load(defaultValue.vtr_id)
        .then(content => setPartialEntity({ meta: content }));
      // pintService
      //   .getPintContent(defaultValue.id)
      //   .subscribe(content => setPartialEntity({ meta: content }));
    }
  }, []);
 const { loading: loading_badges, master: reputation } = usePintMaster('reputation_badge');

  const badges = useMemo(
      () => (Array.isArray(reputation) ? reputation : []),
      [reputation]
    );

  const { resetPagination, ...paginationProps } = useServerPagination(
    ({ page, pageSize }) => {
      if (!expand) {
        return of({ data: [] });
      }
      if (!didMount.current && stopInitialCall) {
        didMount.current = true;
        return of({ data: [] });
      }
      setStopInitialCallRef(prev => false);
      if (resolvedType === EntityType.company) {
                  // 🚨 Stop API call until badges are loaded
          if (loading_badges || badges.length === 0) {
            return of({ data: [], count: 0 });
          }
        return companyService
          .filter_add_entity({
            filters: [
              searchIn === 'name'
                ? {
                    id: 'vtr_company_name',
                    value: {
                      $contains: searchText,
                    },
                  }
                : {
                    id: 'vtr_id',
                    value: {
                      $eq: searchText,
                    },
                  },
                  ...addedFilters
            ],
            page,
            pageSize,
          })
          .pipe(
            map(res => ({
              count: res.data.count,
              data: res.data.data.map(d => ({
                ...d,
                setPartialEntity,
                id: d.vtr_id,
                name: d.vtr_company_name,
                projects_count: d.deal_content_count.content_count,
                reputation: d.deal_content_count.reputation,
                reputation_badge: computeReputationBadge(d.deal_content_count.reputation ?? 0,badges),
                connections: d.deal_content_count.connections,
                deals: d.deal_content_count.deal_count,
                country_names: d.hqcountry,
                company_type: (d.company_types || []).map(t => t.name).join(', '),
              })),
            }))
          );
      } else if (resolvedType === EntityType.person) {
        pageSize = isContentPage ? 10 : 30;
        return personService
          .personSearch({
            searchKey: (searchIn as any) || 'name',
            query: searchText,
            page,
            pageSize,
          })
          .pipe(
            map(res => ({
              ...res.data,
              count: res.data.count,
              data: res.data.data.map(d => ({ ...d, id: d.vtr_id, setPartialEntity, refreshTable, isSeller})),
            }))
          );
      } else if (resolvedType === EntityType.content) {
        const urlMap = {
          normalize: d => {
            d = { data: d };
            return d;
          },
        } as const;
        return contentService
          .filter({
            filters:
              searchInContent === 'content_vtr_id'
                ? [
                    {
                      id: 'vtr_id',
                      value: {
                        $contains: searchText,
                      },
                    },
                  ]
                : searchInContent === 'title'
                ? [
                    {
                      id: 'title',
                      value: {
                        $contains: searchText,
                      },
                    },
                  ]
                : searchInContent === 'imdb_id'
                ? [
                    {
                      id: 'imdb_id',
                      value: {
                        $contains: searchText,
                      },
                    },
                  ]
                : searchInContent === 'tmdb_id'
                ? [
                    {
                      id: 'content_id',
                      value: {
                        $contains: searchText,
                      },
                    },
                  ]
                :[],
            page,
            pageSize,
          })
          .pipe(
            map(res => ({
              count: res.data.count,
              data: res.data.data.map(d => ({
                ...d,
                setPartialEntity,
                switchBackToContentForm,
                isDealForm,
                id: d.vtr_id,
                content_type: d.content_type == 0 ? 'Movie' : d.content_type == 2 ? 'Book' : d.content_type == 3 ? 'Podcast' : d.content_type == 4 ? 'Game' : d.content_type == 5 ? 'Format' :d.content_type == 6 ? 'Story' :d.content_type == 7 ? 'IP' :d.content_type == 8 ? 'Micro-Series' : 'TV Series',
              })),
            }))
          );
      }

      return pintService
        .search(resolvedType.toLowerCase() as any, {
          query: searchText,
          start: pageSize * (page - 1),
          limit: pageSize,
          ...(searchText && resolvedType === EntityType.content
            ? { sort: 'asc', sort_key: 'title' }
            : {}),
        })
        .pipe(
          map(res => ({
            data: (res.data[Object.keys(res.data)[0]] as Array<any>).map(d => ({
              ...d,
              id: d.vtr_id,
              setPartialEntity,
            })),
            count: typeof res._pages === 'string' ? 0 : res._pages.total,
          }))
        );
    },
    { defPageSize: isContentPage? 10: 30 },
    [resolvedType, searchTrigger, expand,loading_badges]
  );

  useEffect(()=>{
    if(!paginationProps?.loading && tableReload){
      setSearchTrigger(t => t + 1);
      setTableReload(false)
      toggleExpanded();
    }
  },[tableReload])

  // Auto-select first result when pendingAutoSelect is true and data is loaded
  useEffect(() => {
    if (pendingAutoSelect && !paginationProps?.loading && paginationProps?.rows?.length > 0) {
      const firstResult = paginationProps.rows[0] as any;
      if (firstResult && firstResult.name && firstResult.vtr_id) {
        // Check if the first result is a good match (at least 70% similarity or exact match)
        const searchTerm = autoSelectSearchText.toLowerCase();
        const resultName = firstResult.name.toLowerCase();
        const isGoodMatch = resultName.includes(searchTerm) || searchTerm.includes(resultName);
        
        if (isGoodMatch) {
          // Auto-select the first result
          setPartialEntity({
            name: firstResult.name,
            vtr_id: firstResult.vtr_id,
            type: resolvedType,
            meta: firstResult,
            relation_type: entity.relation_type,
          });
          
          // Collapse the dropdown after selection
          if (expand) {
            toggleExpanded();
          }
        }
      }
      
      // Reset auto-select state
      setPendingAutoSelect(false);
      setAutoSelectSearchText('');
    }
  }, [paginationProps?.loading, paginationProps?.rows, pendingAutoSelect, autoSelectSearchText, resolvedType, entity.relation_type, expand]);

  const noId = !entity.vtr_id;
  const noName = !entity.name;
  const noType = !entity.type;
  const noValue = noId && noName;
  const showEditIcon = noId && titleEditable;
  const isTypeEditable = noId && !fixedType;
  const onTypeClick = () => {
    // Toggle Type on Click
    if (isTypeEditable) {
      setPartialEntity({
        type: resolvedTypeValue === EntityType.company ? EntityType.person : EntityType.company,
      });
    }
  };

  const clearContent = () => {
    setPartialEntity({
      vtr_id: '',
      name: '',
      meta: null,
      type: null,
      deal_content_genre: null,
      language: null,
      country_of_origin: null,
      imdb_id: null,
      deal_content_type: null,
      working_title: null,
      book_name: null,
      deal_season: null,
      original_title: null,
    });
  };

  const updateEntityName = value => {
    setPartialEntity({ name: value, type: resolvedTypeValue, meta: null });
  };
  const updateType = evt => {
    const value = evt.target.value as EntityType;
    setType(() => value);
    // Side effects
    resetPagination();
  };

  //resize the inputbase to width equal the length of the value
  const reSizeInputBase = () => {
    let length = entityNameEl.current.firstChild.value.length;
    entityNameEl.current.style.width = `${length ? length * 1.2 : 16}ch`;
  };

  //After fresh load of input base resize the width equal to the length of the value
  //Use timeout since the inputbase is created asynchronosuly
  const freshLoadInputBaseToUpdateWidth = () => {
    setTimeout(() => reSizeInputBase(), 0);
  };

  const [createRequestOpen, , showCreateRequestDialog, hideCreateRequestDialog] = useToggle(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const onCreateRequestFinish = useCallback(requestData => {
    const infoNotification = enqueueSnackbar('Please wait Creating Company Request', {
      variant: 'info',
    });
    return companyRequestService.create(requestData).subscribe({
      next: () => {
        enqueueSnackbar('Company Request Created Successfully!', { variant: 'success' });
        setbadgeContentForCompanyState(prevVal => prevVal + 1);
        hideCreateRequestDialog();
      },
      error: err => {
        enqueueSnackbar(`Error Creating company request (${err?.response?.data?.error})`, {
          variant: 'error',
        });
      },
      complete: () => closeSnackbar(infoNotification),
    });
  }, []);

  const [badgeContentForCompanyState, setbadgeContentForCompanyState] = useState(0);
  useEffect(
    () =>
      setbadgeContentForCompanyState(
        dealData && dealData.company_requests
          ? dealData.company_requests.filter(eachRequest => eachRequest.company_name == entity.name)
              .length
          : 0
      ),
    [dealData && dealData.company_requests ? dealData.company_requests : null]
  );

  //Only for CONTENT
  /*Season field is just an indicator that the component is in deal Add/Edit page and we need to disable 
  the edit icon because we are passing "SeasonField" only in Deal Add/Edit page*/
  const isInDealEditPage : Boolean = SeasonField ? false : true;
  useEffect(()=>{
    if(!isInDealEditPage){
      //this directly opens the search dialog
      toggleExpanded()
    }
  },[])

  const onPersonCompanyCreated = (payload) => {
  // payload = { personVtrId, companyVtrId, relation }
  setPartialEntity({
    type: EntityType.person,
    vtr_id: payload.personVtrId,
    name:payload.personName,
    meta: {
      ...payload,
      selectedCompany:{...payload,designation:payload.designation}
    }
  });
};

  return (
    <Card className={clsx(noValue && !expand && classes.disabledCard)} elevation={2}>
      <CardHeader
        subheader={label}
        avatar={
          <Avatar
            onClick={onTypeClick}
            style={{
              cursor: isTypeEditable && 'pointer',
            }}>
            <EntityIcon disabled={noValue} type={resolvedTypeValue} />
          </Avatar>
        }
        title={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{  maxWidth:"430px" /* width: '100%' */ }}>
              <>
                <div style={{display:'flex',flexDirection:'row', alignItems:'center'}}>
                  {entityNameEditable ? (
                    <>
                      <InputBase
                        autoFocus
                        placeholder="Enter an entity"
                        defaultValue={entity.name}
                        onBlur={toggleEntityNameEditable}
                        className={classes.inputBaseStyle}
                        inputProps={{ 'aria-label': 'Edit entity name' }}
                        onChange={event => {
                          updateEntityName(event.target.value);
                          reSizeInputBase();
                        }}
                        ref={entityNameEl}
                        onFocus={freshLoadInputBaseToUpdateWidth}
                      />
                    </>
                  ) : (
                    <Typography
                      variant="h5"
                      color={noName ? 'textSecondary' : 'inherit'}
                      display="inline"
                      style={{
                        marginRight: showEditIcon ? 0 : 10,
                        lineHeight: 1.334,
                        fontSize: '1.5rem',
                      }}
                      className={classes.hoverEditEntity}>
                    {/*   {(<ClipBoard
                                    parentValue={entity.name}
                                    icon={<CopyClipboard style={{ fontSize: '1.2em' }} color="primary" />}
                                    value={entity.vtr_id ? entity.vtr_id : 'No Vitrina ID associated'}
                                  />) || (
                        <span className={classes.inputBaseStyle}>Select an entity</span>
                      )} */}
                      {entity?.name ? (
                        <>
                          <ClipBoard
                            parentValue={entity.name}
                            icon={
                              <CopyClipboard
                                style={{ fontSize: '1.2em', marginLeft: 6 }}
                                color="primary"
                              />
                            }
                            value={entity?.vtr_id || 'No Vitrina ID associated'}
                          />
                        </>
                      ) : (
                        <span className={classes.inputBaseStyle}>Select an entity</span>
                      )}
                      {resolvedTypeValue == EntityType.company ||
                      resolvedTypeValue == EntityType.content ? (
                        <Tooltip title="Edit">
                          <span>
                            {isInDealEditPage && (
                              <BsPencilSquare
                                onClick={toggleEntityNameEditable}
                                className={classes.editEntity}
                                style={{ fontSize: '1rem', marginLeft: '2px' }}
                                color="primary"
                                fontSize="small"
                              />
                            )}
                          </span>
                        </Tooltip>
                      ) : (
                        '  '
                      )}
                    </Typography>
                  )}

                  <Typography
                    style={{
                      marginRight: 15,
                      cursor: isTypeEditable && 'pointer',
                      userSelect: isTypeEditable ? 'none' : 'auto',
                    }}
                    color="textSecondary"
                    variant="body2"
                    onClick={onTypeClick}
                    display="inline">
                    {capitalCase(resolvedTypeValue)}
                  </Typography>
                </div>
                {entity.vtr_id && entity.type ? (
                  // <Chip
                  //   size="small"
                  //   component={Link}
                  //   target="_blank"
                  //   href={vtrUrl(entity.id, entity.type)}
                  //   icon={<LaunchIcon />}
                  //   label={`ID: ${entity.id}`}
                  //   clickable
                  //   color="primary"
                  // />
                  <IdentifiedEntityChips
                    entity={entity}
                    isContentPage={isContentPage}
                    isC3={isC3}
                    isQP={isQP}
                    isC2C={isC2C}
                    setEntityValue={setPartialEntity}
                    type={fixedType}
                    isSeller={isSeller}
                    badges= {badges}
                  />
                ) : (
                  <ColoredChip
                    colored={noValue ? grey[600] : red[700]}
                    coloredHover={noValue ? grey[600] : red[900]}
                    size="small"
                    icon={noValue ? <AiOutlineInfoCircle /> : <NotInterestedRoundedIcon />}
                    label={noValue ? 'Empty' : 'Not Identified'}
                  />
                )}
              </>
            </div>
            {SeasonField && <div style={{ width: '270px', marginLeft: '10px' }}>{SeasonField}</div>}
          </div>
        }
        action={
          <React.Fragment>
            {clearable && !noValue && (
              <Tooltip title="Clear">
                <IconButton aria-label="remove content" onClick={clearContent} disabled={disabled}>
                  <BackspaceIcon />
                </IconButton>
              </Tooltip>
            )}
            {isDealEntityRemovable && (
              <Tooltip title="delete entity">
                <IconButton onClick={() => removeDealEntities(indexOfEntities)} disabled={disabled}>
                  {/* <AiFillMinusCircle style={{ fontSize: '1.5rem', marginLeft: '2px' }} /> */}
                  <DeleteIcon style={{ fontSize: '1.5rem' }} />
                </IconButton>
              </Tooltip>
            )}
            {isDealEntityRequestCreatable &&
              noId &&
              !noName &&
              resolvedTypeValue == EntityType.company && (
                // || resolvedTypeValue == EntityType.content
                <>
                  <Tooltip title="Create Company Request">
                    <StyledBadge
                      // anchorOrigin={{
                      //   vertical: 'bottom',
                      //   horizontal: 'right',
                      // }}
                      badgeContent={badgeContentForCompanyState}
                      color="error">
                      <IconButton onClick={showCreateRequestDialog} disabled={disabled}>
                        {/* <AiFillMinusCircle style={{ fontSize: '1.5rem', marginLeft: '2px' }} /> */}
                        <AddToQueueIcon style={{ fontSize: '1.5rem' }} />
                      </IconButton>
                    </StyledBadge>
                  </Tooltip>
                  {createRequestOpen && (
                    <CreateEntityRequest
                      dealData={dealData}
                      entityData={entity.name}
                      open={createRequestOpen}
                      onClose={hideCreateRequestDialog}
                      onOk={onCreateRequestFinish}
                      onCancel={hideCreateRequestDialog}
                    />
                  )}
                </>
              )}
            {companyPublishable && (
              <>
                {entity.publish == -1 ? (
                  <Tooltip title="UnPublished">
                    <IconButton
                      onClick={() => setPartialEntity({ publish: 1 })}
                      style={{ color: 'red' }}>
                      <CancelIcon style={{ fontSize: '1.5rem' }} />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip title="Published">
                    <IconButton
                      onClick={() => setPartialEntity({ publish: -1 })}
                      style={{ color: 'green' }}>
                      <CheckCircleIcon style={{ fontSize: '1.5rem' }} />
                    </IconButton>
                  </Tooltip>
                )}
              </>
            )}
            {contentPublishable && (
              <>
                {entity.publish == -1 ? (
                  <Tooltip title="UnPublished">
                    <IconButton
                      onClick={() => setPartialEntity({ publish: 1 })}
                      style={{ color: 'red' }}>
                      <CancelIcon style={{ fontSize: '1.5rem' }} />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip title="Published">
                    <IconButton
                      onClick={() => setPartialEntity({ publish: -1 })}
                      style={{ color: 'green' }}>
                      <CheckCircleIcon style={{ fontSize: '1.5rem' }} />
                    </IconButton>
                  </Tooltip>
                )}
              </>
            )}
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expand,
              })}
              onClick={toggleExpanded}
              aria-expanded={expand}
              aria-label="show more"
              disabled={disabled}>
              <ExpandMoreIcon />
            </IconButton>
          </React.Fragment>
        }
      />
      <Collapse in={expand} mountOnEnter unmountOnExit>
        <CardContent>
          <Grid container justify="space-between" spacing={2}>
            {!hideTypeSelect && (
              <Grid item>
                <FormControl style={{ minWidth: 100 }}>
                  <InputLabel id="entity-select-label">Entity Type</InputLabel>
                  <Select
                    labelId="entity-select-label"
                    id="entity-select"
                    value={resolvedType}
                    onChange={updateType}>
                    <MenuItem value={EntityType.company}>Company</MenuItem>
                    <MenuItem value={EntityType.person}>Person</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}
            {showSearchIn && (
              <Grid item>
                <TextField
                  value={searchIn}
                  onChange={evt => setSearchIn(evt.target.value as string)}
                  select
                  SelectProps={{ native: true }}
                  label="Search By">
                  <option value="name">Name</option>
                  <option value="vtr_id">Vitrina Id</option>
                  {fixedType === EntityType.person && (
                    <>
                      <option value="hubspot_id">Hubspot Id</option>
                      <option value="imdb_id">IMDB Id</option>
                      <option value="tmdb_id">TMDB Id</option>
                    </>
                  )}
                </TextField>
              </Grid>
            )}
            {showSearchContentIdVtrId && (
              <Grid item>
                <TextField
                  value={searchInContent}
                  onChange={evt => setSearchInContent(evt.target.value as string)}
                  select
                  SelectProps={{ native: true }}
                  label="Search By">
                  <option value="title">Title</option>
                  <option value="content_vtr_id">Vitrina Id</option>
                  <option value="imdb_id">IMDB Id</option>
                  <option value="tmdb_id">TMDB Id</option>
                </TextField>
              </Grid>
            )}
            <Grid item xs={showSearchContentIdVtrId && page !== COMPANY_TO_CONTENT ? 8 : true}>
              <SearchBox
                onSearch={text => {
                  setSearchText(text);
                  setSearchTrigger(t => t + 1);
                  resetPagination();
                }}
                defautlValue={searchText}
                label={`Search`}
              />
            </Grid>
            {showSearchContentIdVtrId && page !== COMPANY_TO_CONTENT && (
              /* page !== CONTENT_TO_PERSON  &&*/ <Grid item xs>
                <Button
                  onClick={() => {
                    addNonIdContentForm(searchText ?? '');
                    toggleExpanded();
                  }}
                  variant="contained"
                  color="primary">
                  Create New
                </Button>
              </Grid>
            )}
          </Grid>
          <br />
          {searchText && (
            <Typography variant="caption" color="textSecondary">
              Showing Results for <strong>"{searchText}"</strong>
            </Typography>
          )}
          <br />
          <TableContainer>
            <div style={{ width: '100%' }}>
              <EntitySearchResult
                {...paginationProps}
                density="compact"
                rowsPerPageOptions={null}
                disableColumnFilter
                disableColumnMenu
                disableColumnReorder
                disableColumnResize
                disableColumnSelector
                disableSelectionOnClick
                disableDensitySelector
                disableMultipleColumnsFiltering
                disableMultipleSelection
                disableMultipleColumnsSorting
                disableExtendRowFullWidth
                // rowHeight={100}
                // autoPageSize
                autoHeight
                type={type}
                paginationMode="server"
                // txtMessage={txtMessage}
                entity={entity}
                onPersonCompanyCreated={onPersonCompanyCreated}
                addNonIdContentForm={addNonIdContentForm}
                searchText={searchText}
                isContentPage={isContentPage || isC3}
              />
            </div>
          </TableContainer>
        </CardContent>
      </Collapse>
    </Card>
  );
})

const TableContainer = styled.div`
  // display: flex;
  // height: 300px;
  // overflow-y: auto;
  // & * {
  //   ${thumbStack}
  // }
  .MuiDataGrid-root .MuiDataGrid-colCell,
  .MuiDataGrid-root .MuiDataGrid-cell {
    padding: 0px 8px;
  }
`;

const IdentityInformationMap = {
  [EntityType.company]: CompanyInformation,
  [EntityType.person]: PersonInformation,
  [EntityType.content]: ContentInformation,
};

function IdentifiedEntityChips({ entity, setEntityValue, type, isSeller = false, isContentPage = false,isC3 = false,isQP=false,isC2C=false,badges}: { entity: EntitySearchModel, setEntityValue: any, type: String, isSeller: boolean, isContentPage : boolean,isC3:boolean, isQP:boolean,isC2C:boolean,badges:any}) {
  let Details = IdentityInformationMap[entity.type];
 // console.log("entity [IdentifiedEntityChips]:",entity)
  const rep_badge = entity?.meta?.reputation_badge?.name
  return (
    <>
      <Chip
        size="small"
        component={Link}
        target="_blank"
        href={`${type === EntityType.person ? `${DELI_ENV_BASE_URL}/person-management/edit/${isContentPage ? entity?.person_vtr_id ? entity?.person_vtr_id : entity?.meta?.id : entity?.vtr_id}`: vtrUrl(entity?.vtr_id, entity?.type)}`}
        icon={<LaunchIcon />}
        label={`ID: ${isContentPage ? entity?.person_vtr_id ? entity?.person_vtr_id : entity?.meta?.id : entity?.vtr_id}`}
        clickable
        color="primary"
      />
     {/*  {entity.type === EntityType.company &&  <Chip
      label={rep_badge || 'N/A'}
      size="small"
      style={{
        marginRight: 10,
        backgroundColor: getBadgeColor(rep_badge || 'N/A'),
        color: '#fff',
        fontWeight: 500,
      }}
    />} */}
      {Details && (
        <>
          <Details entity={entity} isContentPage={isContentPage} isC3={isC3} isQP={isQP} isC2C={isC2C} setEntityValue={setEntityValue} isSeller={isSeller} badges={badges}/>
        </>
      )}
    </>
  );
}

const loadingSkeleton = <Skeleton animation="wave" width="30%" />;

function ContentInformation({
  entity,
  setEntityValue,
  isC3,
}: {
  entity: EntitySearchModel;
    setEntityValue: any;
  isC3: boolean;
}) {
  const { loading, data: content } = useContentLoader(entity.vtr_id);

  const release_date = !loading && content && new Date(content.release_date);
  const year =
    !loading && content && isValid(release_date)
      ? release_date.getFullYear()
      : content?.production_year
      ? content?.production_year
      : 'NA';
  return !loading && content ? (
    <ContentInfo
      entity={entity}
      setEntityValue={setEntityValue}
      type={content.content_type}
      language={content.lang_names}
      year={year}
      isC3={isC3}
      original_title={content.original_title == content.title ? null : content.original_title}
    />
  ) : (
    loadingSkeleton
  );
}
function CompanyInformation({
  entity,
  badges,
  isC2C=false,
}: {
  entity: EntitySearchModel;
  badges: any;
  isC2C: boolean;
}) {
  const { loading, data: company } = useCompanyLoader(entity.vtr_id);

  const badgesReady = Array.isArray(badges) && badges.length > 0;
  const companyReady = !loading && company;

  const reputationLoading =
    companyReady &&
    company?.reputation &&
    !badgesReady;

  let reputation: any;

  if (companyReady && badgesReady && company?.reputation) {
    reputation = computeReputationBadge(company.reputation ?? 0, badges);
  }

  if (!companyReady) return loadingSkeleton;
  return (<>
    <CompanyInfo
      type={company.company_types[0]?.name}
      hq={company.hqcountry}
      rep_badge={
        reputationLoading
          ? null
          : entity?.meta?.reputation_badge?.name || reputation?.name
      }
      showReputation={true}
      color="#0000008a"
      reputationLoading={reputationLoading}
    />
    <div style={{ display: 'flex', alignItems: 'center', flexDirection:"row", gap: 8 }}>
     {isC2C && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

          <span style={{ color: 'black', flexShrink: 0, fontWeight:500 }}>Deal Date : </span>
          <input
            value={entity?.meta?.relation_date ?? ''}
            readOnly
            style={{
              height: '30px',
              width: '350px',
              border: '1px solid darkgray',
              borderRadius: '3px',
              padding: '10px',
            }}
          />
        </div>
      )}
       {isC2C && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

          <span style={{ color: 'black', flexShrink: 0 , fontWeight:500}}>Deal Value : </span>
          <input
            value={entity?.meta?.deal_value ?? ''}
            readOnly
            style={{
              height: '30px',
              width: '350px',
              border: '1px solid darkgray',
              borderRadius: '3px',
              padding: '10px',
            }}
          />
        </div>
      )}
      </div>
      </>
  );
}

function PersonInformation({
  entity,
  setEntityValue,
  isSeller = false,
  isContentPage = false,
  isC3=false,
  isQP=false,
}: {
  entity: EntitySearchModel;
  setEntityValue: any;
  isSeller: boolean;
  isContentPage: boolean;
  isC3:boolean,
  isQP:boolean,
}) {
  const { loading, data: person } = usePersonLoader(
    `${isContentPage ? entity?.person_vtr_id : entity.vtr_id}`
  );
  return isContentPage ? (
    <PersonInfo
      role={person?.role_id || ''}
      isContentPage={isContentPage}
      entity={entity}
      setEntityValue={setEntityValue}
      isSeller={isSeller}
    />
  ) : !loading && person ? (
    <PersonInfo
      role={person.role_id}
      isContentPage={isContentPage}
      isC3 = {isC3}
      entity={entity}
      setEntityValue={setEntityValue}
      isSeller={isSeller}
      isQP={isQP}
    />
  ) : (
    loadingSkeleton
  );
}

const PersonInfo = ({ role, entity, setEntityValue, isSeller = false, isContentPage = false,isC3 = false,isQP=false}) => {
  const [roleInDeal, setRoleInDeal] = useState((entity?.meta?.selectedCompany?.designation || entity?.designation || entity?.meta?.designation ||""));
  const [roles, setRoles] = useState(entity?.role);
  const [subRole, setSubRole] = useState(entity?.sub_role);
  const [roleData, setRoleData] = useState([]);
  const [subRoleData, setSubRoleData] = useState([]);
  const { enqueue } = useSnackbarInstance();
  const [character, setCharacter] = useState(entity?.character);
  const [loading, setLoading] = useState(false);
  const [roleTouched, setRoleTouched] = useState(false);
  const [designation, setDesignation] = useState( entity?.meta?.selectedCompany?.designation||entity?.designation  || role);
  //console.log(entity,role)
  // Update entity when roleInDeal changes
 useEffect(() => {
  const personEntity = { ...entity };
  const value = roleInDeal ?? '';

  if (personEntity?.meta?.selectedCompany) {
    personEntity.meta = {
      ...personEntity.meta,
      selectedCompany: {
        ...personEntity.meta.selectedCompany,
        designation: value
      }
    };

  } else {
    personEntity.designation = value;
  }
  setEntityValue(personEntity);
}, [roleInDeal]);

  // Update entity when roles changes
  useEffect(()=>{
    if(isContentPage){
      const personEntity = { ...entity };
      personEntity.role = roles;
      setEntityValue(personEntity);
    }
  },[roles, isContentPage]);

  // Update entity when subRole changes
  useEffect(()=>{
    if(isContentPage){
      const personEntity = { ...entity };
      personEntity.sub_role = subRole;
      setEntityValue(personEntity);
    }
  },[subRole, isContentPage]);

  // Update entity when character changes
  useEffect(()=>{
    if(isContentPage){
      const personEntity = { ...entity };
      personEntity.character = character;
      setEntityValue(personEntity);
    }
  },[character, isContentPage]);
   // Update designation changes
  useEffect(()=>{
    if(isQP){
      const personEntity = { ...entity };
      personEntity.designation = designation;
      setEntityValue(personEntity);
    }
  },[designation, isQP]);

  const companyName = (entity?.meta?.selectedCompany?.name || entity?.company_name);
  //console.log("entity [personInfo]",entity)
  // Load role data on mount
  useEffect(()=>{
    if(entity){
      setLoading(true);
      roleApi.roleSearch().subscribe({
        next: val => {
          setRoleData(val);
        },
        error: val => {
          enqueue(`Error while get Role : ${val}`, { variant: 'error' });
        },
        complete: () => {
          setLoading(false);
        },
      });
    }
  },[entity])
  
  // Load sub-role data when roles changes
  useEffect(()=>{
    if(roles){
      roleApi.subRoleSearch().subscribe({
        next: val => {
          const subRoleList = val[roles] ?? []
          setSubRoleData(subRoleList);
        },
        error: val => {
          enqueue(`Error while get Role : ${val}`, { variant: 'error' });
        },
        complete: () => {
          setLoading(false);
        },
      });
    }
  },[roles])
  
    const [options, setOptions] = React.useState([]);
    const [loadingRoles, setLoadingRoles] = React.useState(false);
    const companyId =  entity?.company_vtr_id ??  entity?.meta?.selectedCompany?.company_vtr_id ??  null;
   const { loading:loadingCompanyDetails, data: company } = useCompanyLoader(companyId);
   
    // Debounced function to fetch role options
    const debouncedSearchRoles = useCallback(
      debounce((searchTerm: string) => {
        setLoadingRoles(true);
        http_v3
          .get('/roles', {
            params: {
              role_name: searchTerm
            }
          })
          .pipe(
            map(res => res.data)
          )
          .subscribe({
            next: data => {
              let rolesArray = [];
              if (Array.isArray(data)) {
                rolesArray = data;
              } else if (data && Array.isArray(data.data)) {
                rolesArray = data.data;
              } else if (data && typeof data === 'object') {
                // If it's an object, try to extract array from common properties
                rolesArray = data.roles || data.items || data.results || [];
              }
              setOptions(rolesArray);
            },
            error: err => {
              console.error(err, 'Error fetching roles');
              setOptions([]); // Set empty array on error
            },
            complete: () => {
              setLoadingRoles(false);
            },
          });
      }, 300),
      []
    );
  
    useEffect(() => {
      // Initial load - fetch all roles
      debouncedSearchRoles('');
    }, [debouncedSearchRoles]);

  return (
    <Typography
      variant="body2"
      color="textSecondary"
      style={{
        display: 'flex',
        justifyContent: 'space-between', // 🔥 key change
        alignItems: 'center',
        gap: '10px',
        paddingTop: '10px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>

     { <span style={{ display: 'inline-flex',
      alignItems: 'center',//  minWidth:100,
      gap: 6,}}><LanguageIcon style={{ fontSize: '1em' }} /> {role}</span>}
      {!(isContentPage || isQP) && companyName && (companyName !== 'No Company') && (
       <span
    style={{
      margin: '0 10px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      whiteSpace: 'nowrap',
      flexShrink: 0,
      color: '#dd1062',
    fontSize: '16px',
    fontWeight: 500,// minWidth:600,
    }}
  >
    <span style={{ color: 'black' }}>Company :</span>

    <span>{companyName},</span>

    {!loadingCompanyDetails && company ? (
      <CompanyInfo
        type={company.company_types[0]?.name}
        hq={company.hqcountry}
        color = '#dd1062'
      />
    ) : (
      loadingSkeleton
    )}
  </span>
      )}
      </div>
      {!(isSeller || isContentPage || isC3 || isQP) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

          <span style={{ color: 'black', flexShrink: 0 }}>Role in Deal : </span>
          <input
            value={roleInDeal ?? ''}
            onChange={e => setRoleInDeal(e?.target?.value)}
            style={{
              height: '30px',
              width: '350px',
              border: '1px solid darkgray',
              borderRadius: '3px',
              padding: '10px',
            }}
          />
        </div>
      )}
      {isQP && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

          <span style={{ color: 'black' }}>Designation : </span>{' '}
          <Autocomplete
            options={options || []}
            value={designation}
            onChange={(e, v) => {
              setDesignation(v);
              setRoleTouched(true);
            }}
            freeSolo
            onInputChange={(e, v) => {
              if (e?.type === 'change') {
                setDesignation(v);
                debouncedSearchRoles(v);
                setRoleTouched(true);
              }
            }}
            style={{ width: '450px' }}
            renderInput={props => (
              <TextField
                label="Select designation"
                name="desgination"
                fullWidth
                variant="outlined"
                onBlur={() => setRoleTouched(true)}
                error={roleTouched && !designation}
                helperText={roleTouched && !designation ? 'Designation is mandatory' : ''}
                {...props}
                InputProps={{
                  ...props.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loadingRoles ? (
                        <>
                          <CircularProgress color="inherit" size={20} />
                          {props.InputProps.endAdornment}
                        </>
                      ) : null}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </div>
      )}
      {isContentPage && (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <>
            <br />
            <CountryStyles>
              <Autocomplete
                value={roles}
                onChange={(evt, v) => {
                  setRoles(v);
                  setRoleTouched(true);
                }}
                onBlur={() => setRoleTouched(true)}
                options={roleData || []}
                style={{ width: '300px', paddingRight: '20px' }}
                renderInput={props => (
                  <TextField
                    label="Role"
                    fullWidth
                    variant="outlined"
                    error={roleTouched && !roles}
                    helperText={roleTouched && !roles ? 'Role is mandatory' : ''}
                    {...props}
                    InputProps={{
                      ...props.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <>
                              <CircularProgress color="inherit" size={20} />
                              {props.InputProps.endAdornment}
                            </>
                          ) : null}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </CountryStyles>
          </>
          <>
            <br />
            <CountryStyles>
              <Autocomplete
                value={subRole}
                onChange={(evt, v) => setSubRole(v)}
                // onInputChange={(evt, v) => onChange && onChange(v)}
                options={subRoleData || []}
                disabled={!roles || loading}
                style={{ width: '300px', paddingRight: '20px' }}
                renderInput={props => (
                  <TextField
                    label="Sub Role"
                    fullWidth
                    variant="outlined"
                    helperText={''}
                    {...props}
                    InputProps={{
                      ...props.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <>
                              <CircularProgress color="inherit" size={20} />
                              {props.InputProps.endAdornment}
                            </>
                          ) : null}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </CountryStyles>
          </>
          <>
            <br />
            <ControlledTextFieldforCharacter
              fullWidth
              variant="outlined"
              character={character}
              setCharacter={setCharacter}
            />
          </>
        </div>
      )}
    </Typography>
  );
  }
interface CompanyInfoProps {
  type: string;
  hq: string;
  rep_badge?: string;
  showReputation?: boolean;
  reputationLoading?: boolean;
  color?: string;
}

const CompanyInfo = ({
  type,
  hq,
  rep_badge,
  showReputation = false,
  reputationLoading = false,
  color,
}: CompanyInfoProps) => (
  <Typography
    variant="body2"
    color="textSecondary"
    style={{ display: 'flex', alignItems: 'center', gap: 4, color }}
  >
    <LanguageIcon style={{ fontSize: '1em' }} color="primary" />
    {hq},

    <CategoryIcon style={{ fontSize: '1em' }} color="secondary" />
    {type}.

    {showReputation && (
      reputationLoading ? (
        <Skeleton
          variant="rect"
          width={60}
          height={24}
          style={{ borderRadius: 12, marginLeft: 4 }}
        />
      ) : (
        rep_badge && (
          <Chip
            label={rep_badge}
            size="small"
            style={{
              margin: 1,
              backgroundColor: getBadgeColor(rep_badge),
              color: '#fff',
              fontWeight: 500,
            }}
          />
        )
      )
    )}
  </Typography>
);

const ContentInfo = ({setEntityValue, type, language, year, original_title,isC3,entity }) => {
  const [roles, setRoles] = useState(entity?.role);
  const [subRole, setSubRole] = useState(entity?.sub_role);
  const [roleData, setRoleData] = useState([]);
  const [subRoleData, setSubRoleData] = useState([]);
    const [loading, setLoading] = useState(false);
  const [roleTouched, setRoleTouched] = useState(false);

  const { enqueue } = useSnackbarInstance();
 // Update entity when roles changes
  useEffect(()=>{
    if(isC3){
      const contentEntity = { ...entity };
      contentEntity.role = roles;
      setEntityValue(contentEntity);
    }
  },[roles, isC3]);

  
  // Update entity when subRole changes
  useEffect(()=>{
    if(isC3){
      const contentEntity = { ...entity };
      contentEntity.sub_role = subRole;
      setEntityValue(contentEntity);
    }
  },[subRole, isC3]);


  // Load role data on mount
  useEffect(()=>{
    if(entity){
      setLoading(true);
      roleApi.roleSearch().subscribe({
        next: val => {
          setRoleData(val);
        },
        error: val => {
          enqueue(`Error while get Role : ${val}`, { variant: 'error' });
        },
        complete: () => {
          setLoading(false);
        },
      });
    }
  },[entity])
  
  // Load sub-role data when roles changes
  useEffect(()=>{
    if(roles){
      roleApi.subRoleSearch().subscribe({
        next: val => {
          const subRoleList = val[roles] ?? []
          setSubRoleData(subRoleList);
        },
        error: val => {
          enqueue(`Error while get Role : ${val}`, { variant: 'error' });
        },
        complete: () => {
          setLoading(false);
        },
      });
    }
  },[roles])
  
  const original_title_nullified = original_title && (
    <>
      <SubtitlesIcon style={{ fontSize: '1em' }} /> {original_title}
    </>
  );
  return (
    <>
    <Typography
      variant="body2"
      color="textSecondary"
      style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <CategoryIcon style={{ fontSize: '1em' }} /> {type},{' '}
      <LanguageIcon style={{ fontSize: '1em' }} /> {language},
      <EventIcon style={{ fontSize: '1em' }} /> {year}
      {original_title_nullified}
    </Typography>
    <br/>
     {isC3 && <>
        <div style={{display:'flex',flexDirection:'row'}}>
                <CountryStyles>
                  <Autocomplete
                    value={roles}
                    onChange={(evt, v) => {
                      setRoles(v);
                      setRoleTouched(true);
                    }}
                    onBlur={() => setRoleTouched(true)}
                    options={roleData || []}
                    style={{width: "300px", paddingRight:"20px"}}
                    renderInput={props => (
                      <TextField
                        label="Role"
                        fullWidth
                        variant="outlined"
                        error={roleTouched && !roles}
                        helperText={roleTouched && !roles ? 'Role is mandatory' : ''}
                        {...props}
                        InputProps={{
                          ...props.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loading ? (
                                <>
                                  <CircularProgress color="inherit" size={20} />
                                  {props.InputProps.endAdornment}
                                </>
                              ) : null}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                </CountryStyles>
       
               
                <CountryStyles>
                  <Autocomplete
                    value={subRole}
                    onChange={(evt, v) => setSubRole(v)}
                    // onInputChange={(evt, v) => onChange && onChange(v)}
                    options={subRoleData || []}
                    disabled={!roles || loading}
                    style={{width: "300px", paddingRight:"20px"}}
                    renderInput={props => (
                      <TextField
                        label="Sub Role"
                        fullWidth
                        variant="outlined"
                        helperText={""}
                        {...props}
                        InputProps={{
                          ...props.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loading ? (
                                <>
                                  <CircularProgress color="inherit" size={20} />
                                  {props.InputProps.endAdornment}
                                </>
                              ) : null}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                </CountryStyles>
        </div>
      
        
      </>}
      </>
  );
};

type EntitySearchResultProps = Omit<DataGridProps, 'columns'> & {
  type: EntityType | `${EntityType}` | string;
  entity: any;
  onPersonCompanyCreated?:any;
  addNonIdContentForm?: (contentTitle: String)=>void;
  searchText?: String;
  isContentPage?: boolean;
};
/**
 * Render a table that remounts every time the type of changes.
 */
function EntitySearchResult({ type, ...props }: EntitySearchResultProps) {
  props.entity.isContentPage = props.isContentPage;
  return (
    <DataGrid
      density="compact"
      key={`${type}-${props.rowCount}`}
    //  columns={contentToColumns(props?.entity)[type || EntityType.company]}
      columns={contentToColumns({
    ...props.entity,
    onPersonCompanyCreated: props.onPersonCompanyCreated
  })[type|| EntityType.company]}
      {...props}
      components={{ NoRowsOverlay: customNoRowsOverlay }}
      componentsProps={{ noRowsOverlay: { txtMessage: type, addNonIdContentForm: props?.addNonIdContentForm, searchText: props?.searchText} }}
    />
  );
}
const customNoRowsOverlay = (props) => {
    let redirectURL = ''
    if(props?.txtMessage == 'CONTENT'){
      redirectURL = '/content/new';
    }
    else if(props?.txtMessage == 'PERSON'){
      redirectURL = '/person-management/new';
    }
    else{
      redirectURL = '/company/new';
    }
    return (
      <Grid
        container
        justify="center"
        alignContent="center"
        style={{ position: 'absolute', top: '20%', height: '100%', zIndex: 999 }}>
        <Grid item>
          <span>No Records Found. {props?.addNonIdContentForm ? <span onClick={()=>props?.addNonIdContentForm(props?.searchText ?? "")} style={{color:"purple", cursor:"pointer"}}>Create New</span> :<Link1 to={redirectURL} target="_blank">Create New</Link1>}</span>
        </Grid>
      </Grid>
    
  );
};
const StyledBadge = withStyles(theme => ({
  badge: {
    right: 5,
    top: 10,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))(Badge);

const CountryStyles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;
